import styled, { css } from 'styled-components'
import { BottomSheet, SurfaceDarkInfo, Tooltip, AnchoredAlert, Text, isMobileStyleMixin } from '@amzn/storm-ui'

const anchorAlertStyle = css`
  & button {
    line-height: 0;
    padding: 0;
  }
`

export const StyledBottomSheet = styled(BottomSheet)`
  z-index: 599;
  & div[data-takt-id*='FIT_POPOVER_mobile'] {
    padding: 0;
    justify-content: flex-end;
  }
  & button {
    font-size: 13px;
    line-height: 1.465;
    padding: 0;
    margin: auto 12px 12px auto;
  }
`

export const ComponentTooltip = styled(Tooltip)`
  ${anchorAlertStyle}
`

export const ComponentAnchoredAlert = styled(AnchoredAlert)`
  ${anchorAlertStyle}
`

export const Surface = styled(SurfaceDarkInfo)`
  padding: 18px;
`

export const Title = styled(Text)`
  font-size: 15px;
  line-height: 19px;
`

export const MobileTitle = styled(Text)`
  font-size: 18px;
  line-height: 26px;
`

export const ContentTextWrapper = styled.div<{ hasTitle: boolean }>`
  ${({ hasTitle }) =>
    hasTitle &&
    css`
      padding-top: ${({ theme }) => theme.spacing.mini};
      ${isMobileStyleMixin(css`
        padding-top: ${({ theme }) => theme.mobile.spacing.mini};
      `)}
    `}
`

export const MobileLinkWrapper = styled.div`
  display: flex;
  justify-content: end;
  padding-top: ${({ theme }) => theme.mobile.spacing.small};
`

export const StyledLink = styled.div`
  &&& > a {
    text-decoration: underline;
    color: ${({ theme }) => theme.palette.white};
  }
  padding-top: ${({ theme }) => theme.spacing.mini};
`
